module.exports = __webpack_public_path__ + "img/np_fan.41998167.svg";